import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IonicModule} from "@ionic/angular";
import {ItemModule} from "../../../../core/component/item/item.module";
import {SummaryFieldModule} from "../../../../core/component/summary-field/summary-field.module";
import {SaleSummaryFieldComponent} from "./sale-summary-field.component";
import {DateLabelModule} from "../../../../core/component/date/date-label/date-label.module";
import {PriceLabelModule} from "../../../../common/price/api/component/price-label/price-label.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ItemModule,
        SummaryFieldModule,
        DateLabelModule,
        PriceLabelModule,
    ],
    declarations: [
        SaleSummaryFieldComponent,
    ],
    exports: [
        SaleSummaryFieldComponent
    ],
})
export class SaleSummaryFieldModule {
}